import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "px-3 h-full lg:px-5" }
const _hoisted_2 = { class: "flex flex-col gap-6 h-full lg:gap-8" }
const _hoisted_3 = {
  key: 0,
  class: "flex-none w-6 lg:w-10"
}
const _hoisted_4 = {
  key: 1,
  class: "ml-4 whitespace-nowrap"
}
const _hoisted_5 = {
  key: 0,
  class: "flex-none w-6 lg:w-10"
}
const _hoisted_6 = {
  key: 1,
  class: "ml-4 whitespace-nowrap"
}
const _hoisted_7 = {
  key: 2,
  class: "flex overflow-hidden -top-2 -right-2 justify-center items-center ml-4 w-5 h-5 text-sm text-white bg-teal-400 rounded-full lg:absolute"
}
const _hoisted_8 = {
  key: 0,
  class: "flex flex-col flex-none gap-6 mt-6 ml-10 font-bold lg:hidden"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Об организации ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Политика конфиденциальности ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Контакты ")
const _hoisted_12 = {
  key: 0,
  class: "flex-none w-6 lg:w-10"
}
const _hoisted_13 = {
  key: 1,
  class: "ml-5"
}

import {
  InformationCircleIcon, PresentationChartLineIcon, CogIcon, ThumbUpIcon, StarIcon, LogoutIcon,
  ScaleIcon
} from '@heroicons/vue/outline';
import {
  computed, reactive, ref, RenderFunction,
} from 'vue';
import axios from 'axios';
import router from '../router';
import { useStore } from '../stores/main';
import { storeToRefs } from 'pinia';
import { breakpointsTailwind, useBreakpoints, useDebounce, useStorage } from '@vueuse/core';
import AppTooltip from './AppTooltip.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const menuOpen = computed(() => store.menuOpen);
const debouncedMenuOpen = useDebounce(menuOpen, 200);
const breakpoints = useBreakpoints(breakpointsTailwind);
const lg = breakpoints.greater('lg');


const icons: { [key: string]: RenderFunction } = {
  InformationCircleIcon,
  PresentationChartLineIcon,
  CogIcon,
  ThumbUpIcon,
  StarIcon,
};

function logout() {
  closeMenu();
  
  try {
    axios.get('/api/logout');
  } catch (error) {
    // do nothingcheck-auth
  }
  
  router.push({
    path: '/login',
  });
}

function handleMouseEnter() {
  openMenu();
}

function handleMouseLeave() {
  closeMenu();
}

function openMenu() {
  //console.log('openMenu', menuOpen)
  store.menuOpen = true;
}

function closeMenu() {
  //console.log('closeMenu', menuOpen)
  store.menuOpen = false;
}

let timeout = null;

function closeMenuWithTimeout() {
  clearTimeout(timeout);
  
  timeout = setTimeout(() => {
    closeMenu();
  }, 300);
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["fixed top-10 bottom-0 z-20 py-6 max-w-[90vw] text-zinc-100 bg-zinc-900 transition-[width] lg:top-24", {'w-80 lg:w-80': _unref(menuOpen), 'w-12 lg:w-20 w-0': !_unref(menuOpen)}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).groups, (item) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            key: item.slug,
            to: '/stats/' + item.slug,
            class: "group flex relative flex-row items-center hover:text-teal-300",
            "active-class": 'text-teal-300 cursor-default',
            onClick: closeMenuWithTimeout
          }, {
            default: _withCtx(() => [
              (_unref(menuOpen) || _unref(lg))
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(icons[item.icon])))
                  ]))
                : _createCommentVNode("", true),
              (_unref(menuOpen))
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(item.title), 1))
                : _createCommentVNode("", true),
              _createVNode(AppTooltip, {
                title: item.title
              }, null, 8, ["title"])
            ]),
            _: 2
          }, 1032, ["to"]))
        }), 128)),
        _createVNode(_component_router_link, {
          to: {name: 'compare', query: {p: _unref(store).compareIds}},
          class: "group flex relative flex-row items-center hover:text-teal-300",
          "active-class": 'text-teal-300 cursor-default',
          onClick: closeMenuWithTimeout
        }, {
          default: _withCtx(() => [
            (_unref(menuOpen) || _unref(lg))
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                  _createVNode(_unref(ScaleIcon))
                ]))
              : _createCommentVNode("", true),
            (_unref(menuOpen))
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, " Сравнение "))
              : _createCommentVNode("", true),
            _createVNode(AppTooltip, { title: "Сравнение" }),
            (_unref(store).compareIds.length && (_unref(menuOpen) || _unref(lg)))
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(store).compareIds.length), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["to"]),
        (_unref(debouncedMenuOpen) && _unref(menuOpen))
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_router_link, {
                "active-class": "text-teal-300 cursor-default",
                to: {name: 'page', params: {slug: 'about'}},
                class: "block hover:text-teal-300",
                onClick: closeMenuWithTimeout
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                "active-class": "text-teal-300 cursor-default",
                to: {name: 'page', params: {slug: 'privacy-policy'}},
                class: "block hover:text-teal-300",
                onClick: closeMenuWithTimeout
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                "active-class": "text-teal-300 cursor-default",
                to: {name: 'contacts'},
                class: "block hover:text-teal-300",
                onClick: closeMenuWithTimeout
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("span", {
          class: "group flex relative flex-row items-center mt-auto hover:text-teal-300 cursor-pointer lg:mt-8",
          onClick: logout
        }, [
          (_unref(menuOpen) || _unref(lg))
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                _createVNode(_unref(LogoutIcon))
              ]))
            : _createCommentVNode("", true),
          (_unref(menuOpen))
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, " Выйти "))
            : _createCommentVNode("", true),
          _createVNode(AppTooltip, { title: "Выйти" })
        ])
      ])
    ])
  ], 2))
}
}

})